import { useEffect, useSyncExternalStore } from 'react';
import { useAccountReadiness } from '@/services/auth/account-readiness';
import {
  hasPendingSignupCompletion,
  subscribePendingSignupCompletion,
  takePendingSignupCompletion,
  trackSignupCompletedEvent,
} from './signup-completed';

const getServerSnapshot = () => false;

/**
 * Fires a parked `Signup: Completed` once the new workspace is ready, from
 * wherever the tab is. Mounted at the root so the event does not depend on
 * any one page (the wizard, its exit) rendering; idle when nothing is parked.
 */
export function usePendingSignupCompletion(): void {
  const hasPending = useSyncExternalStore(
    subscribePendingSignupCompletion,
    hasPendingSignupCompletion,
    getServerSnapshot,
  );
  const { readyResponse } = useAccountReadiness({ enabled: hasPending });

  useEffect(() => {
    if (readyResponse == null) {
      return;
    }
    const pending = takePendingSignupCompletion();
    if (pending != null) {
      trackSignupCompletedEvent(pending);
    }
  }, [readyResponse]);
}
